import { render, staticRenderFns } from "./NumberFormatter.vue?vue&type=template&id=76a70b1d"
import script from "./NumberFormatter.vue?vue&type=script&lang=js"
export * from "./NumberFormatter.vue?vue&type=script&lang=js"
import style0 from "./NumberFormatter.vue?vue&type=style&index=0&id=76a70b1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports